import React from 'react';
import {
  Button,
  ButtonProps,
  Box,
  IconButton,
  Typography,
} from '@material-ui/core';
import { Control, useFieldArray, useForm } from 'react-hook-form';
import {
  AppGroupText,
  AppMultipleSelect,
  AppSelect,
  AppDatePicker,
  AppTextField,
  AppRadioGroup,
  AppCommon,
  AdvancedSelect,
} from 'components/molecules/FormControls';
import phoneCodes from 'assets/data/phone-codes.json';
import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import GridLayout from 'components/molecules/GridLayout';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import _ from 'lodash';

interface MobilePhonesWrapperProps {
  control: any;
  errors: ReturnType<typeof useForm>['formState']['errors'];
  fieldName: string;
}

const PageKey = 'mobilePhonesComponent';

export const MobilePhoneDefault = { phone: null, phoneStart: '+357' };

export type MobilePhonesFieldType = Array<{
  phone: string | null;
  phoneStart: string | null;
}>;

const MobilePhonesField = ({
  errors,
  control,
  fieldName,
}: MobilePhonesWrapperProps) => {
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: fieldName as never, // unique name for your Field Array
    }
  );
  const options = React.useMemo(
    () =>
      phoneCodes.map((el) => ({
        id: el.dial_code,
        label: `${el.code} (${el.dial_code})`,
      })),
    []
  );

  return (
    <React.Fragment>
      {fields.map((item, index) => {
        return (
          <Box key={index} display="flex" alignItems="center">
            <GridLayout
              spacing={0}
              elements={[
                {
                  rowStyle: {
                    paddingRight: '1rem',
                  },
                  element: (
                    // <AppSelect
                    //   variant="outlined"
                    //   margin="normal"
                    //   uniqueId={false}
                    //   error={Boolean(
                    //     _.get(errors, `${fieldName}[${index}].phoneStart`)
                    //   )}
                    //   helperText={_.get(errors, 'phoneStart', '')}
                    //   rules={{
                    //     required: <AppCommon.RequiredField />,
                    //   }}
                    //   options={options}
                    //   fullWidth
                    //   id={`${fieldName}[${index}].phoneStart`}
                    //   control={control}
                    //   controllerExtras={{
                    //     defaultValue: (item as any).phoneStart,
                    //   }}
                    //   name={`${fieldName}[${index}].phoneStart`}
                    //   autoComplete={`${fieldName}[${index}].phoneStart`}
                    // />
                    <AdvancedSelect
                      isClearable
                      placeholder={
                        <TranslatedTextV2
                          defaultText="Phone Start"
                          translationKey={``}
                        />
                      }
                      error={Boolean(
                        _.get(errors, `${fieldName}[${index}].phoneStart`)
                      )}
                      options={options || []}
                      id={`${fieldName}[${index}].phoneStart`}
                      control={control}
                      name={`${fieldName}[${index}].phoneStart`}
                      rules={{ required: <AppCommon.RequiredField /> }}
                      margin={'normal'}
                      helperText={_.get(
                        errors,
                        `${fieldName}[${index}].phoneStart.message`
                      )}
                      controllerExtras={{
                        defaultValue: (item as any).phoneStart,
                      }}
                    />
                  ),
                  id: 'phoneStart',
                  size: 6,
                },
                {
                  element: (
                    <AppTextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id={`${fieldName}[${index}].phone`}
                      label={
                        <TranslatedTextV2
                          defaultText={`Phone Numb. ${
                            fields.length > 1 ? `(${index + 1})` : ''
                          }`}
                          translationKey="client_listing_page.mobilePhones"
                        />
                      }
                      name={`${fieldName}[${index}].phone`}
                      autoComplete={`${fieldName}[${index}].phone`}
                      control={control}
                      error={Boolean(
                        _.get(errors, `${fieldName}[${index}].phone`)
                      )}
                      helperText={_.get(
                        errors,
                        `${fieldName}[${index}].phone.message`
                      )}
                      rules={{
                        required: <AppCommon.RequiredField />,
                      }}
                      controllerExtras={{
                        defaultValue: (item as any).phone,
                      }}
                      icon={
                        index > 0
                          ? {
                              ComponentRight: (
                                <IconButton
                                  style={{
                                    color: 'red',
                                    padding: 0,
                                    margin: 0,
                                  }}
                                  onClick={() => remove(index)}
                                >
                                  <RemoveCircleOutlineOutlinedIcon />
                                </IconButton>
                              ),
                            }
                          : undefined
                      }
                    />
                  ),
                  id: 'phone',
                  size: 6,
                },
              ]}
            />
          </Box>
        );
      })}

      <Button
        onClick={() => {
          append({
            ...MobilePhoneDefault,
          });
        }}
        style={{ textTransform: 'none' }}
        variant="text"
        color="secondary"
      >
        <TranslatedTextV2
          defaultText="+ Add another phone number"
          translationKey={`${PageKey}.addAnotherPhoneNumber`}
        />
      </Button>
    </React.Fragment>
  );
};

export default MobilePhonesField;
